<template>
  <div>
    <div
      :id="`modal-container-${id}`"
      class="dynamic-component modal-portal-window"
    >
      <WhyModal
        v-if="showModal"
        :close-modal="close"
        :title="content.title"
        :allow-full-width="content.allowFullWidth || false"
        :overflow-visible="content.overflowVisible || false"
      >
        <div
          :id="componentContainerId"
          :style="content.modalHeight && `maxHeight: ${content.modalHeight}px`"
        >
          <component
            :is="content.component"
            v-bind="content.props"
            @action-complete="close"
          />
        </div>
      </WhyModal>
    </div>
  </div>
</template>

<script>

import {v4 as uuidv4} from "uuid";
import WhyModal from "~/components/WhyModal/WhyModal";

export default {
  components: {WhyModal},
  props: {
    content: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    removeById: {
      type: Function,
      required: true
    }
  },
  data() {
    const componentContainerId = uuidv4();
    return {
      componentContainerId,
      showModal: true,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.handleEscape);
  },
  unmounted() {
    this.removeEventListeners();
  },
  methods: {
    close() {
      this.showModal = false;
      this.removeEventListeners();
      this.removeById(`${this.content.id}`);
    },
    remove() {
      document.body.classList.remove("no-scroll");
    },
    removeEventListeners() {
      window.removeEventListener('keydown', this.handleEscape);
    },
    handleEscape(e){
      if (e.key === 'Escape') {
        this.remove();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-portal-window {
  z-index: 101;
  position: fixed;
}
</style>
